import type { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { ensureAuthUserLoaded } from "@core/router/building.routes"
import PageBuildingOptimisationContractuelle from "./pages/PageBuildingOptimisationContractuelle.vue"
import PageComparateurOffres from "./pages/PageComparateurOffres.vue"

export const buildingShellChildren = [
    {
        path: "courtage/comparateur-offres",
        name: "PageComparateurOffres",
        component: PageComparateurOffres,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (authStore.hasOfferCourtage) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
    {
        path: "optimisation-contractuelle",
        name: "PageBuildingOptimisationContractuelle",
        component: PageBuildingOptimisationContractuelle,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            // Optimisation TURPE = analyse métier : ❌ pour le rôle Utilisateur
            // (table des droits DEV-16282). Même garde que le dashboard parc
            // (beforeEnterDashboardOptimTurpe).
            if (
                authStore.hasModuleOptimTurpe &&
                authStore.isEmployeWriteOrHigher
            ) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
] as RouteRecordRaw[]
